// removed by extract-text-webpack-plugin
module.exports = {"root":"dh-kult-hnio-root","root--js":"dh-kult-hnio-root--js","root--noJs":"dh-kult-hnio-root--noJs","saksuniversContainer":"dh-kult-hnio-saksuniversContainer"};


//////////////////
// WEBPACK FOOTER
// ./src/v1/client.css
// module id = 91
// module chunks = 0